<template>
  <div class="img-uploader"
       @drop="handleDrop"
       ref="uploader">

    <!--没有图片显示点击上传-->
<!--     <p class="img-uploader-placeholder" v-if="!hasImages">{{placeholder}}</p> -->

    <!--图片预览列表-->
    <div class="img-uploader-preview-list">
      <div class="img-uploader-preview">
        <div class="preview-img">
<!--          <img @click="chooseWXImg" v-if="imgUrl" :src="imgUrl" width="100%"/>-->
          <img @click="chooseWXImg" v-if="imageDataList.length === 0" :src="defaultImg" width="100%"/>
        </div>
      </div>
    </div>

<!--    <label :for="inputId" class="img-uploader-label" v-if="!hasImages"></label>-->

<!--    &lt;!&ndash; input&ndash;&gt;-->
<!--    <input-->
<!--      style="display: none"-->
<!--      :id="inputId"-->
<!--      ref="input"-->
<!--      type="file"-->
<!--      accept="image/*"-->
<!--      @change="handleFileChange"/>-->
    <!--错误提示-->
    <!-- <div class="img-uploader-error" v-if="errorText.length">{{errorText}}</div> -->

    <!--文件数-->
    <!-- <div class="img-uploader-count" v-if="countText.length">{{countText}}</div> -->

  </div>
</template>

<script>
// import resizeImage from '../../assets/js/resize.js'

export default {
  props: {
    // 占位文字
    placeholder: {
      default: '点击上传图片',
      type: String
    },
    // 文件更改回调
    onChange: {
      type: Function
    },
    // 图片大小的最大值(KB)
    maxSize: {
      default: 3072,
      type: Number
    },
    defaultImg: {},
    upType: {}
  },
  data () {
    return {
      // input 的id
      inputId: '',
      // 预览图片地址
      imageDataList: [],
      // 文件名
      fileNameList: [],
      // 错误提示
      errorText: '',
      // 图片计数
      countText: '',
      imgUrl: '',
      imgUrlList: [],
    }
  },
  computed: {
    // 是否有图片
    hasImages () {
      return this.imageDataList.length > 0
    },
    // 格式化的文件大小，可读的
    sizeFormatted () {
      let result = 0
      if (this.maxSize < 1024) {
        result = this.maxSize + 'K'
      } else {
        result = (this.maxSize / 1024).toFixed(this.maxSize % 1024 > 0 ? 2 : 0) + 'M'
      }
      return result
    }
  },
  mounted () {
    console.log(this.imageDataList)
    // let file = this.dataURLtoFile("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQQAAAEECAYAAADOCEoKAAAbkklEQVR4Xu2d63rcRgxDk/d/6PSz28aX2HuORCytjdG/MyQBkAONZNf5+evXr18/+l8VqAJV4MePHz9rCJ2DKlAF/leghtBZqAJV4LcCNYQOQxWoAjWEzkAVqAJ/KtAbQqeiClSB3hA6A1WgCvSG0BmoAlXghgL4yvDz589vIyD9SsaGFoThqRmEw+S4d1MJo6m/wSOB03C5wh6jZw3hVadIsI3hIQw1hOzR2uhpFvH5bGq26BeTKthLAza0UE2DW5vJcX6sXGRCqw0eCZxOka/fZfTsDaE3hLtMauKgmQGegk/gnGLYijd61hBqCHeZx8RBMwM8BZ/AOcWwFW/0rCHUEO4yj4mDZgZ4Cj6Bc4phK97oWUOoIdxlHhMHzQzwFHwC5xTDVrzRs4ZQQ7jLPCYOmhngKfgEzimGrXij59gQTJEtwrfqmMYTF5NjypUwTPOn4kmLBA+q8cRlWmejRkpzykNcjFY1hAe8IdBgbKwnho9wUo0awlsFSa8awiu9SCwzXCYHDTmtm6ZRjo110iLBg2qYnpEWGzUIQ2qduJie9IbQG8KpeUwMHxWmGjWE3hBohj5dTwyXyXEa4H+BxsWnNRLxpEWCB9WoIdQQTs9yYrhMjtMAawh/SGf0nhrPRo3pTNh44mK06itDXxnsvL3Zlxg+Kkw1ekPoDYFmqK8MpxU6FkiH1TyNqCLVqCHUEGiGaginFToWSIe1hnBMz8TuRE9WXhkIaEIMGkCDYZqD4p94GhykB9WhGhSfwkk8NtaJK2llbiEmx5Qr8TA9Uzmmfw9BFVn4q0uEwzRtmoPiTdPM4FAd4krxKZyGy733EFfSqobwrkMkGAm+NVyEg3gkGk8YUlpQHeJK8Smc9z7sJj9xJa0Sc2Fw0h7iYXqmcvSG8NIKEoyGh+JN02gwEgO6hdNwufce4ko9Teid4Eg8zGypHDWEGsJHA2sOSmLQ752DDoHhmcgx5UkYagjvFCbBNhpPGEzTzOBQHeJK8Smchsu99xBX0qo3hHcdIsFI8K3hIhzEI9F4wpDSguoQV4pP4bz3YTf5iStplZgLg5P2EA/TM5Wjrwx9Zegrw+3jSAfJmAodeFonDDWEC74yUFNTTxszHLewXGWASS+Dc0MLqmFwEldaJww1hBoCzdCn61cZYCJgcJqDMjVHqmFwEldaJww1hBoCzVANQShkDjMdRpNDQLm5hTDUEGoIp2fsKgNMBAxOc1B6Q/hXAaNV/1+GV9NCgpkBpSFP1KAchCHBg2pMMZonnh3yGkIN4Y8ZMIeAhtjkmB4UU4NwEgZTg3LQ+hRjDeGtwkZP6qvK0R87vghPgpHgdEjME83UIJyEw9SgHLQ+xVhDqCHQjN1cpwE0hyCRg0gkalAOwmC0oBy0PsVYQ6gh0Ix9uSGMAC4GJw48HehEDZKEMFC8WTc8CIfJYbDc2kMYjIGqHH1l8K8M06ZuxScGlIYnUYP0IAwUb9YND8JhchgsNYSpSq/iE02jHEG4d02VGFDSIlGDRCAMFG/WDQ/CYXIYLDWEqUo1hA8VTAzooxyC6QgZrR5FC+JCPJ5fO/rK0FeGjw4VDQ8N3/SgPsUThkQNw4NwmBxTrISh3xDeKUyCmaZRjmlTt+INV8JCWiRqTDFQvFk3PB5FC+JCPHpDOGgqZsCusIcGw2Ck4UnUIByEgeLNuuFBOEwOg6XfEKYq9RtCvyEMZ8gc5hrCK5FJMBLLvNsMe/ocTjiIh8mRwLmRw3AlHAk9qQatEwaKN+tGK8Jhchgs3+aGMBUjEW+aNm08xRseBqfJc+89xNXw2MhBOiRwUo2tdeJCej8/vDd+yrAlyK06JJa5IVAOIzhpQTUofmuduBoeGzlIjwROqrG1TlxI7xrCu06RYAnBaTioBsVvrU+1ShiwyUF6GL2JK9XYWicuhkdvCK+6RYIlBKfhoBoUv7U+1cocZqMF4SA9NmoQhtQ6cTFa1RBqCKfmkYaLhrOGcEr2m0GkOfWsrwx9ZTg9lTRcNJw1hNPSfxpImlPPagg1hNNTScNFw1lDOC19DSEh3caA0iExPAxOk+fee4ir4bGRg3RI4KQaW+vEhfSO3BC2yG7UIcEigv/8eZMKYXhu2jAHxSee3hs8trTYmL2NGqon099D2CCyVYMEo4NE8YkBTuQgHjWErYnbraPms4bw0hQSjA4SxScOcyIH8agh7B7UrWpqPmsINYSPBpKGh0yF4hPGlshBPLYO60Yd1ZMaQg2hhrBxHL++Rg3hYA9IMHqaUHziiZbIQTz6ynBwcB5ku5rP3hB6Q+gN4UFO9BBmDeGggCQYPVkpPvF0T+QgHr0hHBycB9mu5rM3hN4QekN4kBM9hBkxhCGGbxWeePIawagONZ7izQ2BcJoalMOsE1eTo3teFMD/27FieQXMIUgMMNWhGhRfQ/A9/9t21hCCHd04aFf5hkCyGS0oh1kn8zM5uqc3hLvMgDkEiQGmOlSD4ntDuMt4PETS3hCCbdo4aL0hvG0YmV+wvd8iVQ0h2OYawqurJ/wfmSnZawgpJf/NU0MI6llDqCEEx+lLUtUQgrLXEGoIwXH6klRoCGbICfn0WpfAQBgTH9JMDdpjuJKeJgfhoPUrYCCMqZ6SnqSF+e5juEz3KJwbv6logNwiSw2ZCvV//BRnAofhSjhNjinWK2AwHAinyUF6mhqUw+CY7lE4awgvMhvBpk2heDM4hNPkIBy0fgUMhLE3hLcKUc+ebzI1hBqCOVjv99BwbZiSwU04TQ7iYmpQDoNjukfhrCHUEM4MGg3XFQ5Abwi9IZyZ7d8xNOSj5DLYHCTCaXJIOJ9uuwIGw4Fwmhykp6lBOQyO6R6FszeE3hDODBoN1xUOQG8IvSGcme3eEE6oVkM49iC5gkFSzyIfFVWR4a+xJmqYHCfOxZuQRNMNTqpjcky5JuKvwIMwJHheJYeZi/FPGVSRGoKeiYSeJocGdMeNdBg3eBCGO9JfT230rCEE25IYLtW04T/lFqQ8SkV6GS1GAMQ/izfNf6V4o2cNIdgxGnBTSjWthmCkVHsSPVOFLrBJzdb0pwyqSF8Z9Dgk9DQ5NKA7bqTDuMGDMNyR/npqo2dvCMG2JIZLNa03hFjXEj2LgblzIjVbvSHkupAYLtW0GkKsaYmexcDcOZGarRpCrguJ4VJNqyHEmpboWQzMnROp2aoh5LqQGC7VtBpCrGmJnsXA3DmRmq2pIdyZg05PZDcaTxgMmQ2cBsd0T0KLKYan+A09H4WrwTn+qJhoWiIHkX2UwdjAmdCbclA/KD61vqHno3A1OGsIqcn78eOHEZzKbQwwYUisJ7RI4NjQ81G4Gpw1hMTU/ZfDCE7lNgaYMCTWE1okcGzo+ShcDc4aQmLqagh/qGiGLyj9p6lqCC/SmJ7UEIJTaQSnchsDTBgS6wktEjg29HwUrgZnDSExdb0h9IYQnKOzqcj8agivlCWxzjbhdZwRnOps4CQMifWEFgkcG3o+CleDE28IiaZQDmqaIvIgv6xDXEmrp3XSg2pQvMFAewgDxafWiavBSTlSWG/lMTgJh+FRQyAVw+sbjaUaZjCmtAnDNL+NJ64GJ+WwWCb7DE7Kb3jUEEjF8PpGY6mGGYwpbcIwzW/jiavBSTkslsk+g5PyGx41BFIxvL7RWKphBmNKmzBM89t44mpwUg6LZbLP4KT8hkcNgVQMr280lmqYwZjSJgzT/DaeuBqclMNimewzOCm/4VFDIBXD6xuNpRpmMKa0CcM0v40nrgYn5bBYJvsMTspveNQQSMXw+kZjqYYZjCltwjDNb+OJq8FJOSyWyT6Dk/IbHjUEUjG8vtFYqmEGY0qbMEzz23jianBSDotlss/gpPyGRw2BVAyvbzSWapjBmNImDNP8Np64GpyUw2KZ7DM4Kb/hgYaQADIFuoHhCSMJRjgo/qnGRo6p3gmcxJMwmn4YnFRnq2eEg9aNnoYL1rnCX0wiIkYMImrWpzgo3gxwIgdxTdSgHImeUQ2j5xW0IAxm3ehp9KJavSG8UogEpaZQvBngRA5qeqIG5SCtCGNvCG8VMnpST4zmNYQawodzQgNIw0fxZjiphjFYqpOoYXIQDlo3eiZw1BBqCDUEOI10GBMHsYYQPIgkpl2nxiYGYyMH8SWe5slLOYgnYewrQ18ZPp2RxHAlBpBw0CFJHDSTg7hu4CStCGMNoYZQQxA/+qwhHD8ot8xnwxyN+dEeY7CGC9Z5hB87EglzSCJiDf8Va/vUM3xv7THDM62xEW96RlwpB8Vv8DRzkcBJWjyfoxqCb/lWUzyij3cmcE4xJOLVAA//UtZVtCKuCZxUo4ZwcGq3mnIQ1h/bEzinGBLxaoBrCFpqpWdvCFpP/LVjk8k0xeTpK8O/CpD5kd4UP+2Fjd/ASTV6Q7Dd+m9fYnhMUw7C6g3hhmCkd6Kn0371G8I7BalpRnBq7EYNgzOBg+qQFhR/lXWjFXGlHBS/pcUGTqrRG8LBbieGxzTlIKzeEHpDUCNjZq8/ZVBSuvdVk8o0xeTpNwTXE9I7YfLTfj3UK0OCLOW4SlMIJ63T8D1fyYZfxQlDan0DZ6IG5SA9Ej2jGokDn8CpctBPGQzZ6Z5pU6f1U/FK8BrCb7mp7wk9qbcbNWoI1IV36zQYB9N92fbEcJkcGwSpJwmciRqUg7QyPKY1agjUhRrCpwqZAT0o76ntdAgSOBM1KAeRNzymNWoI1IUaQg0h9D1lelhrCG9HEX/KcPBsn9o+beqponcISgyXyXEH6H+kpJ4kcCZqUA7SyvCY1ugNgbrQG0JvCL0hvJkBMp2Ecakc/SnDQfe6sV0J3p8y/FZw4xBQdxM9oxq9IRiFXu2hwTiY7su2J4bL5NggSD1J4EzUoBykleExrfFXGcKjiEGNN+sJrqbOrT2JAaUchiflIJ6mBuUwGKgO5aD4xGE2OUgLg5NykBZP8fhRcQMI1TBESAyzTjhMjukew5VwUg6Kf6gBHr6CJbRI5KC5MTUoB81FDeGdggnRqSm0rpp2gUNAPBJaPooWhqvhcktTU4N6YjD0hnCxbxmqaTWE312jg0J6Ury5LSVy0GE2NSgHadEbQm8In86QGZ5LPNEuYI7msD6MnvRjR0N26kxUYyom4ft/nXDYPJN9hivhpBwUb56KxNHUoBzE4/mJVkMgGX+vKz1rCC960nBp5QcbVdMucAiIYkLLR9HCcDVcLnHjqiHUED4axIcZ4AuY47cyhI0nAdUw6zTAG00zOGlPAqfJQTgSem7UmOKkeOJg16knhIPiE6956qMiETZAKUdi/SqCTrkYPRNcCeej1JjipHjSya5TXwkHxdcQ3nXiKoLaAflsX6LxJgfhTOi5UWOKk+KJg12nnhAOiq8h1BA+nUUzPDTIiQHdqDHFSfHEwa5TTwgHxdcQagg1BPGvZdNBooNoDzztm+Kg+BpCDaGGUEN4MwMJc8NfXZ46H8Wn1kmMLYed8kngNDkIZ0LPjRpTnBRPHOw69YRwUHxvCL0h9IbQG8L+DcE4k3XJs/vIPc/m/Yo40tNwTeQg7lSD4hPrRotpHcOTcCRyEA9Tg3IQj6d4fGVIACGgtG6IUI6rrJOehmsiB+lBNSg+sW60mNYxPAlHIgfxMDUoB/GoIZCCd1inxqqmDX9d19AinCbHdI/RYlrD8CQciRzEw9SgHMSjhkAK3mGdGquaVkOIdYb68VSIepLIQYRMDcpBPGoIpOAd1qmxqmk1hFhnqB81hHdSG8Fi3fkkkTkk98aQyk96Gq6JHMSHalB8Yt1oMa1jeBKORA7iYWpQDuLRGwIpeId1aqxqWm8Isc5QP3pD6A0hNmwfJaIBrCG8qGa0mDaL+lFDqCFMZ+xmPA2gOQSJHESSalB8Yt1oMa1jeBKORA7iYWpQDuKhXhmoyFXWE4JNuRjBqcYVeBBG89Q0OYir0ZNyEA5Tg3JMMVB+qzfhMFzxF5MM2CvsITE2MBrBCccVeBBGO6CUh7gaPSkHYTA1KMcUA+W3ehMOw7WGYLoh9xjBKRU1leK31je4mhpTvUwN0nSKgfLXEIxC7/ZsNIVgPcpwEQ+zvsHV1Jj23dQgPaYYKH8NwShUQzihUi5k4yCZGtPDaGqQalMMlL+GYBSqIZxQKReycZBMjelhNDVItSkGyl9DMArVEE6olAvZOEimxvQwmhqk2hQD5a8hGIVqCCdUyoVsHCRTY3oYTQ1SbYqB8v91hkCCUVMo3gpmhL+1x+CY1jDxU70o3mCgPQmtNnASj6usb+m58mNHIkONp/gawtuxJb1I78QhIAymxgZOg+MKe7b0rCEc6HaiKQfKfbqVDgrhpPgERsJgamzgNDiusGdLzxrCgW4nmnKgXA3h16+EXH9FjsTsGYOtIRwYl0RTDpSrIdQQfs9AYvZqCInT9ypHoikJSNRYwknxCYyEwdTYwGlwXGHPlp69IRzodqIpB8r1htAbQm8IH50CcxA3niYGR+LAUw7iSjgpnuqbdcJgcmzgNDiusGdLz94QDnQ70ZQD5XpD6A3hejeEjUNATwKD4Qo5CMNTd4lLIgeZTqIG5SCeTxgpB/EwepocV9izoYWpgTcE09ipoATUYLhCDsJgBjiRg/qRqEE5Ej0jHkZPk+MKe0hPg5E0NzVqCK+UJsEiggf+YjLhoOEhnuagUQ6DkXIQD4PT5LjCng0tTI0aQg3hw/NAB5qGi+L7yvBWdtLTmBZpbmrUEGoINQRz2u68xxxWglBDCB5m88SKCN5Xht9d2zgEdIiusr6hhanRG0LQVJTgNYQawgcuZGaHzCvywPoFSKgIgTTrJIbBcIUchMF8BEvkIM0TNShHomfEw+hpclxhD+lpMJLmpgbeEAyQ77KHBE/oYJpGdTZwEoYED6phDGEDh9H7CjgMhhqCmbr/9pjGH0j34VbTNKqxgZMwJHhQjRrCW4Wo76YnNQQzdTWEAyr9u9UM3+GkHwQkDsEUB2HY0oNwmJ7UEA5MAwl+INWnW03TqM4GTsKQ4EE1ekPoDcHMyN32bBy0xEHawEkiJ3hQjRpCDcHMyN32bBy0xEHawEkiJ3hQjRpCDcHMyN32bBy0xEHawEkiJ3hQjRpCDcHMyN32bBy0xEHawEkiJ3hQjRrCFxjCFYbLDEZiz8YQk54bGIxWhNPkoD3ENYEhUSORg7SgdcKQMkf8KUOiKUT2KutG9ClW0nMDg+FAOE0O2kNcExgSNRI5SAtaJww1BFLwxLoR/UTaNyE05BsYDAfCaXLQHuKawJCokchBWtA6YaghkIIn1o3oJ9LWED4RjfSuIbwIR1rVEKYn84N4I/q0LA35BgbDgXCaHLSHuCYwJGokcpAWtE4Yagik4Il1I/qJtL0h9IYwHRv1q+BkoGa++1HxVauMYNPOJpo2xWDiCafJQXtI7wSGRI1EDtKC1glDbwik4Il1I/qJtL0h9IYwHZveEMYKnkhQQ3gRLfF0phaQ3gkMiRqJHKQFrROGy9wQDFAiu7Fuhou4mBzEhWpQfKLxGzxMDdLC5CC9qAbFm/UNnKZGguv4G0IChBF9uichqMlBOBN6EQ6qQfHE4Wk9USORg7BSDYo364+ip+Iy/ZuKG4IbIrTHNI24mByEg2pQfG8IRqGXPQm9qeLGXJgaCa69IbzqNglqmkLDQzUovoZgFKohHFPpZXcNoYZwanbI2Ix5JnIQeKpB8WbdcKU8hNPUoByE4flh01cG/zQxTSHRI00b/tsOGzxMDdLC5NjQm2ps4DQ1SE/iUUN4pxAJappColMNiu8rg1HIm/yxbB/v3pgLUyMyW70h+OExTaEBizStNwSS+fd6Qm8qtjEXpkaC68orgyFDotM6iWEwTHNQPHEwT/+nPVTHcCUsVIPiDQaqYXIQjqusE9er4KwhvOoENY0GlOJN06lGDcGoeL09idnYYFVDqCF8OGfTAb6KsW0cIlNjqqepkdhTQ6gh1BASJwly1BBeCWSeFtOekOAGwzQHxRuOGzgNjimXq/AwXDf2TPXcwPj8DWvjpwxmOKaESXCDYZqD4g3HDZwGx5TLVXgYrht7pnpuYKwhvFOZmkZDTvGmqVSjHxWNitfbk5iNDVa9IfQbQr8hLJy0GkK/IZwas94QXmQzWpwS+QuCagh/oSHQHCUG2AwO1TE5iAutJzBQDsKQeH0yWhFOk4O4JGpEcvSj4kurpo2lhtBQmAF//vAz/NVlg4P2JDBQDsJg9KIapueJHMQlUSOSo4ZQQ6Bh/Wg9MnxgbAYXHegNnITB8LgKzn5UPPBRkRpLTaV488TrDeGtinQYqScUv6X3VXDWEGoIxqf+2LMxwAYYHegNnITB8LgKzhpCDcHMaw3hhko1hIOHiNzv1ES+C6KmGAyUg3CaGpTDYKA6JgfhoPUEBspBGMwrFtUwWiVyEJdEjUiOflTsR0Ua1n5U/HlTImMqpHHkMAd++tRXhoO3nVuNpaYmnmg0WF0/9tFxSy8zG/fGYoyrhlBDuPccfml+cwg2ANYQXqm8IQY13mCgHDQ4iRomB+Hoeu41MKXlFfpq5rs3hN4QUjN/yTzmEGwAryH0hvDhnNGAXmFwNg7IVg3SewvHFfpqtOgNoTeErTPxJXXMIdgAVkPoDaE3hI2TBjVqCMe+p/SG0BvCBY7t/SDUEC5oCPdrt89srmw0PJSD4p/QUg7DiOpQDYo3GGgPYaD4p3WDk+pQDoo3OEwO4pvAOa3xPJ8bv6lIQDfWTdOmTaH4GsKxTif0pBwbc2FYJ3BSHapRQ3inIAlGw0PxNQQa2bfrCT0pB/W0N4R3PSPBSPBjI3C/3cQj0XijhcFBKlAdqkHxVN+sEwaTw+CkOpSD4hNzkeBqcFId0qI3hN4QaIZOr68N8PB/6DE46SCZHCTkFWrUEGoINKen1zcOiXkFSxy0RA4S8go1agg1BJrT0+s1hGPS1RCO6TXebQZ02hSKN080Q5TqEFeKNxhoD2GgePPubvQkrgZnIgfxvUKN3hB6Q6A5Pb1uDholp0NSQyAF364rPae/h3AM0rV3k2BbQ04qTXEQz6scNNLB4KQcCS2ohr3t3Mpjem64ENbxLyZRgUdaJ0FNU4gv1aD4qxwC4mG0ohyPooXBOeW6pmdvCC/tpKaZptBwUA2KryG8VWjaE9OPaY3eEMxUX3APDccVBqOGUEP47OjQ/Joj11eGVyqRoDWE7G2K9FYDPPzn4AyGK/TdYDBcSNMaQg3hwxmhAaTho/jENfoqtyU6ZAmua3r2G0L2qUfDQQeJ4q9yCIjH2gD3hvB7ZKgnarZqCDWEjwaFDjQNH8UnnppXMUdz0EgvyrGmJxkCAe16FagCf48C+A3h76FaJlWgCpACNQRSqOtV4BspUEP4Rs0u1SpACtQQSKGuV4FvpEAN4Rs1u1SrAClQQyCFul4FvpECNYRv1OxSrQKkQA2BFOp6FfhGCvwDIo8Ke/Bq5UYAAAAASUVORK5CYII=")
    // console.log(file)
    // 防止多个组件互相影响
    this.inputId = this.id || Math.round(Math.random() * 100000);
    ['drop', 'dragenter', 'dragover', 'dragleave'].forEach((eventName) => {
      this.preventDefaultEvent(eventName)
    })
    console.log(this.defaultImg)
  },
  methods: {
    handleFileChange (e) {
      this.handleFile(e.target.files, true)
    },
    handleDrop (e) {
      // 获取文件列表
      let files = e.dataTransfer.files
      this.handleFile(files, false)
    },
    preventDefaultEvent (eventName) {
      document.addEventListener(eventName, function (e) {
        e.preventDefault()
      }, false)
    },
    async chooseWXImg () {
      let that = this
      let res = await this.$axiox.asyncPost(
        '/pay/getSdkConfig?url=' +
        encodeURIComponent(window.location.href)
      )
      this.$wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: res.appId, // 必填，公众号的唯一标识,管理公众号页面可以获取
        timestamp: res.timestamp, // 必填，生成签名的时间戳,后台返回
        nonceStr: res.nonceStr, // 必填，生成签名的随机串,后台返回
        signature: res.signature, // 必填，签名,后台返回
        jsApiList: ['openLocation', 'getLocation', 'chooseImage', 'uploadImage'] // 必填，需要使用的JS接口列表,写入自己用到的接口名称
      })
      this.$wx.ready(p => {
        this.$wx.chooseImage({
          count: 9,
          sizeType: ['original', 'compressed'],
          sourceType: ['album', 'camera'],
          success: function (res) {
            if (res.localIds && res.localIds.length > 0) {
              this.imgUrlList = []
              setTimeout(function () {
                for (let i = 0; i < res.localIds.length; i++) {
                  that.$wx.getLocalImgData({
                    localId: res.localIds[i].toString(), // 图片的localID
                    success: function (getLocal) {
                      var localData = getLocal.localData // localData是图片的base64数据，可以用img标签显示
                      let file = that.dataURLtoFile(localData)
                      that.newUploadFile(file)
                    },
                    fail: function (res) {
                      console.log(res)
                    }
                  })
                }
              }, 100)
            }
          }
        })
        // this.$wx.chooseVideo({
        //   maxDuration: 30,
        //   camera: 'back',
        //   success(res) {
        //     console.log(res.tempFilePath)
        //   }
        // })
      })
      // document.getElementById(this.inputId).click()
    },
    async newUploadFile (file) {
      let fileId = await this.$commonJs.uploadIdCardFile(file, 1)
      this.imgUrlList.push(fileId.imageUrl)
    },
    dataURLtoFile (dataurl) {
      let arr = dataurl.split(',')
      let bstr = atob(arr[1] || dataurl)
      let n = bstr.length
      let u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], '1.jpg', {type: 'image/jpg'})
    },
    deleteImg (index) {
      this.imageDataList.splice(index, 1)
      this.countText = `${this.imageDataList.length}张图片`
    },
    // 处理图片
    handleFile (files, status) {
      if (files && files.length > 0) {
        this.fileNameList.length = 0
        this.imageDataList.length = 0
      }

      for (let i = 0; i < files.length; i++) {
        let file = files[i]
        let size = Math.floor(file.size / 1024)
        if (size > this.maxSize) {
          this.errorText = `文件大小不能超过${this.sizeFormatted}`
          return false
        }
        this.fileNameList.push(file.name)
      }

      if (files && files.length > 0) {
        this.countText = `${files.length}张图片`
      }
      // 文件选择事件
      //        this.onChange && this.onChange(files)
      console.log(files)
      // console.log(this.changeFlieName(files[0]))
      if (status) {
        this.changeFlieName(files[0])
      }

      // this.$emit('onChange', this.getObjectUrl(files[0]))
      // this.$emit('onChange', files)

      this.preview(files)
    },
    // 预览图片
    preview (files) {
      let _this = this
      if (!files || !window.FileReader) return

      for (let i = 0; i < files.length; i++) {
        let file = files[i]
        console.log(file)
        // console.log(this.getObjectUrl(file))
        let reader = new FileReader()
        reader.onload = function (e) {
          // resizeImage(e.target.result, 150, 150, function (result) {
          // console.log(result)
          console.log(e)
          _this.imageDataList.push(e.target.result)
          // })
        }
        reader.readAsDataURL(file)
      }
    },
    async changeFlieName (e) {
      this.imgUrl = ''
      let file = e
      // if (file.size > 500 * 1024) {
      //   this.$commonJs.showTips('图片大小不得超过500K')
      //   return
      // }
      let fileId = await this.$commonJs.uploadIdCardFile(file, 1)
      this.imgUrl = fileId.imageUrl
      this.$emit('onChange', this.imgUrl)
      // return fileId
      // this.myList.imgUrl = fileId
      // e.target.value = ''
    }

    // getObjectUrl (file) {
    //   var getUrl = null
    //   if (window.createObjectURL !== undefined) { // basic
    //     getUrl = window.createObjectURL(file)
    //   } else if (window.URL !== undefined) { // mozilla(firefox)
    //     getUrl = window.URL.createObjectURL(file)
    //   } else if (window.webkitURL !== undefined) { // webkit or chrome
    //     getUrl = window.webkitURL.createObjectURL(file)
    //   }
    //   return getUrl
    // }
  }
}
</script>

<style scoped>

  .img-uploader {
    position: relative;
    display: inline-block;
    width: 100%;
    /* height: calc(150px + 25px * 2); */
    /* width: auto; */
    border-radius: 5px;
    /* background: #ebebeb; */
  }

  .img-uploader-placeholder {
    /*margin: 0;*/
    /*position: absolute;*/
    /*font-size: 15px;*/
    /*width: 100%;*/
    /*color: #aaa;*/
    /*text-align: center;*/
    /*top: 50%;*/
    /*transform: translate(0%, -50%);*/
  }

  .img-uploader-preview-list {
    /*margin: 5px 10px;*/
    /* height: calc(150px + 18px * 2); */
    /*width: 100%;*/
    white-space: nowrap;
    overflow: hidden;
    overflow-x: auto;
    -webkit-backface-visibility: hidden;
    -webkit-perspective: 1000;
    -webkit-overflow-scrolling: touch;
    text-align: center;
  }

  .img-uploader-preview {
    display: inline-block;
    z-index: 2;
    /* min-height: 150px; */
    /*margin: 10px;*/
    border-radius: 10px;
    /*background: #333;*/
    transition: 0.3s cubic-bezier(0.3, 0, 0.2, 1);
  }

  .img-uploader-preview:hover {
    transform: scale(1.02);
  }

  .img-uploader-preview:hover .img-uploader-mask {
    display: block;
  }

  .img-uploader-preview:hover .img-uploader-delete-btn {
    display: block;
  }

  .img-uploader-preview .preview-img {
    width: 100%;
    height: 100%;
    overflow: hidden;
    background-color: #fff;
  }

  .img-uploader-label {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    cursor: pointer;
    margin-bottom: 0;
  }

  .img-uploader-mask {
    display: none;
    position: absolute;
    bottom: 0;
    /* width: 150px; */
    border-radius: 1px;
    text-align: center;
    background: rgba(0, 0, 0, 0.6);
  }

  .img-uploader-delete-btn {
    display: none;
    position: absolute;
    top: 0;
    right: 0;
    margin: 5px;
    width: 25px;
    height: 25px;
  }

  .img-uploader-file-name {
    color: white;
    font-size: 5px;
    padding-top: 10px;
    margin: 0;
    display: inline-block;
    max-width: 90%;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    cursor: pointer;
  }

  .img-uploader-error {
    color: #e55;
    font-size: 12px;
    position: absolute;
    bottom: -28px;
    width: 100%;
  }

  .img-uploader-count {
    color: #573e51;
    font-size: 12px;
    position: absolute;
    bottom: -28px;
    width: 100%;
  }

</style>
